if (!customElements.get('cotigo-virgen-bundle')) {
  customElements.define('cotigo-virgen-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.offers = JSON.parse(this.querySelector('[data-bundle-config]').textContent); }
      catch (_) { return; }
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-bundle-add]');
        if (button && !button.disabled) this.add(button.dataset.bundleAdd);
      });
      this.render();
      this.syncClock();
      if (this.hasAttribute('data-compare-prices')) {
        this.refreshPricing();
        this.priceTimer = setInterval(() => { if (!document.hidden) this.refreshPricing(); }, 60000);
      }
      this.tick = setInterval(() => { if (!document.hidden) this.render(); }, 1000);
      this.clockTick = setInterval(() => { if (!document.hidden) this.syncClock(); }, 60000);
    }

    disconnectedCallback() { clearInterval(this.priceTimer); clearInterval(this.tick); clearInterval(this.clockTick); this.ready = false; }

    async syncClock() {
      try {
        const response = await fetch(this.dataset.root + 'cart.js?_cotigo_bundle_clock=' + Date.now(), {cache:'no-store', credentials:'same-origin'});
        const epoch = Date.parse(response.headers.get('date'));
        response.body?.cancel().catch(() => {});
        if (response.ok && Number.isFinite(epoch)) { this.epoch = epoch; this.received = performance.now(); }
      } catch (_) { /* Coupon timing stays unverified until a server clock is available. */ }
      this.render();
    }

    now() {
      return this.serverEpoch ? this.serverEpoch + (performance.now() - this.clockStarted) / 1000 : 0;
    }

    priceFor(offer) {
      const regular = offer.basePrice + offer.partnerPrice;
      const fallback = { total: regular - offer.discount, source: 'Precio con descuento del conjunto', individual: false };
      if (!this.hasAttribute('data-compare-prices')) return fallback;
      const p = offer.pricing, now = this.now();
      if (!p || p.version !== 2 || !p.enabled || p.country !== 'ES' || p.currency !== 'EUR' ||
          !now || p.generatedEpoch > now || p.validUntilEpoch <= now || p.validUntilEpoch - p.generatedEpoch > 900) {
        return { ...fallback, source: 'Precio final según promociones aplicables en el carrito' };
      }
      const eligible = (entries, original) => (entries || []).filter(e =>
        e.original === original && Number.isInteger(e.price) && e.price > 0 && e.price < original &&
        e.startsEpoch <= now && now < e.endsEpoch);
      const bases = [null, ...eligible(p.baseOffers, offer.basePrice)];
      const partners = [null, ...eligible(p.partnerOffers, offer.partnerPrice)];
      let best = fallback;
      for (const a of bases) for (const b of partners) {
        if (a && b && a.id !== b.id && !(a.combinesWithProductDiscounts === true && b.combinesWithProductDiscounts === true)) continue;
        const total = (a?.price ?? offer.basePrice) + (b?.price ?? offer.partnerPrice);
        if (total < best.total) best = { total, source: 'Mejor precio con ofertas individuales', individual: true };
      }
      if (!best.individual) best.source = offer.discount ? 'Mejor precio con descuento del conjunto' : 'Precio habitual del conjunto';
      return best;
    }

    async refreshPricing() {
      if (this.refreshing || this.busy) return;
      const section = this.closest('[id^="shopify-section-"]');
      if (!section) return;
      this.refreshing = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
        const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('price_refresh_failed');
        const date = Date.parse(response.headers.get('Date')) / 1000;
        if (!Number.isFinite(date)) throw new Error('missing_server_clock');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const config = doc.querySelector('cotigo-virgen-bundle [data-bundle-config]');
        if (!config) throw new Error('missing_bundle_config');
        const offers = JSON.parse(config.textContent);
        if (!Array.isArray(offers)) throw new Error('invalid_bundle_config');
        this.offers = offers;
        this.serverEpoch = date;
        this.clockStarted = performance.now();
      } catch (_) {
        this.serverEpoch = 0;
      } finally {
        this.refreshing = false;
        this.render();
      }
    }

    validPrice(offer) {
      if (!Number.isInteger(offer.basePrice) || !Number.isInteger(offer.partnerPrice) || offer.basePrice <= 0 || offer.partnerPrice <= 0 || offer.basePrice !== offer.expectedBasePrice || offer.partnerPrice !== offer.expectedPartnerPrice) return false;
      const total = offer.basePrice + offer.partnerPrice;
      if (offer.type === 'none') return !offer.code && offer.discount === 0;
      if (!offer.code || !Number.isInteger(offer.discount) || offer.discount <= 0 || offer.discount >= total) return false;
      if (offer.starts || offer.ends) {
        if (!this.epoch) return false;
        const now = (this.epoch + performance.now() - this.received) / 1000;
        if (now < offer.starts || offer.ends && now >= offer.ends) return false;
      }
      return offer.type === 'amount' || Number.isInteger(offer.percent) && offer.percent > 0 && offer.percent <= 100 && offer.discount === Math.round(total * offer.percent / 100);
    }

    render() {
      const money = cents => '€' + (cents / 100).toLocaleString('es-ES', {minimumFractionDigits:2,maximumFractionDigits:2});
      for (const row of this.querySelectorAll('[data-bundle-row]')) {
        const offer = this.offers.find(item => item.id === row.dataset.bundleRow);
        const valid = offer && this.validPrice(offer);
        row.querySelector('[data-bundle-add]').disabled = !offer?.available || !valid || !!this.busy;
        row.querySelector('[data-bundle-prices]').hidden = !valid;
        row.querySelector('[data-bundle-discount]').hidden = !valid || !offer?.available || !offer.discount;
        const unavailable = row.querySelector('[data-bundle-unavailable]');
        unavailable.hidden = !!offer?.available && !!valid;
        unavailable.textContent = !valid ? 'Conjunto en actualización' : 'No disponible en este color';
        if (!offer) continue;
        if (valid) {
          const total = offer.basePrice + offer.partnerPrice;
          const price = this.priceFor(offer);
          row.querySelector('[data-bundle-total]').textContent = money(price.total);
          const source = row.querySelector('[data-bundle-price-source]');
          if (source) { source.hidden = !this.hasAttribute('data-compare-prices'); source.textContent = price.source; }
          row.querySelector('[data-bundle-discount]').textContent = price.individual ? 'Mejor oferta' : offer.label || (offer.percent ? '−' + offer.percent + '%' : '');
          row.querySelector('[data-bundle-discount]').hidden = !offer.available || (!offer.discount && !price.individual);
          row.querySelector('[data-bundle-regular]').textContent = money(total);
          row.querySelector('[data-bundle-regular]').parentElement.hidden = price.total >= total;
        }
        for (const item of ['base', 'partner']) {
          row.querySelector(`[data-bundle-${item}-image]`).src = offer[`${item}Image`];
          const link = row.querySelector(`[data-bundle-${item}-link]`);
          const url = new URL(link.href);
          url.searchParams.set('variant', offer[item + 'Id']);
          link.href = url.href;
        }
      }
    }

    async request(path, body) {
      const response = await fetch(this.dataset.root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No se ha podido actualizar el carrito.');
      return data;
    }

    async notifyCart(cart) {
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: 'update', context: 'product', lines: [],
          promise: Promise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { source: 'cotigo-virgen-bundle', itemCount: cart.item_count }
          })
        }));
      } catch (_) { /* The cart link remains available if the header cannot refresh. */ }
    }

    async add(id) {
      const offer = this.offers.find(item => item.id === id);
      if (this.busy || !offer?.available || !this.validPrice(offer)) return;
      this.busy = true;
      this.render();
      this.setAttribute('aria-busy', 'true');
      const status = this.querySelector('[data-bundle-status]');
      const cartLink = this.querySelector('[data-bundle-cart]');
      let added = false;
      let discountConfirmed = true;
      status.textContent = 'Añadiendo tu conjunto…';
      try {
        const cart = await this.request('cart.js');
        await this.request('cart/add.js', { items: [
          { id: offer.baseId, quantity: 1 },
          { id: offer.partnerId, quantity: 1 }
        ] });
        added = true;
        let actual;
        if (offer.code) {
          const codes = (cart.discount_codes || []).map(entry => entry.code).filter(code => !/^VIRGEN12-|^CV12-|^NUDO8-|^NUDO10-/i.test(code));
          codes.push(offer.code);
          await this.request('cart/update.js', { discount: [...new Set(codes)].join(',') });
          actual = await this.request('cart.js');
          const applied = (actual.discount_codes || []).some(entry => entry.code.toLowerCase() === offer.code.toLowerCase() && entry.applicable === true);
          if (!applied) {
            const prices = [offer.baseId, offer.partnerId].map(id => (actual.items || []).find(item => String(item.variant_id) === String(id) && item.quantity > 0)?.final_price);
            const betterAutomaticPrice = prices.every(Number.isInteger) && prices.every(price => price >= 0) && prices[0] + prices[1] <= offer.basePrice + offer.partnerPrice - offer.discount;
            discountConfirmed = betterAutomaticPrice;
          }
        }
        if (!actual) actual = await this.request('cart.js');
        await this.notifyCart(actual);
        status.textContent = discountConfirmed
          ? 'Conjunto añadido. Puedes añadir otro o ver tu carrito.'
          : 'Conjunto añadido. Revisa en el carrito las promociones aplicables antes de continuar.';
        cartLink.hidden = false;
      } catch (error) {
        status.textContent = added
          ? 'Las piezas se han añadido. No hemos podido confirmar este descuento; revisa las ofertas disponibles en tu carrito antes de continuar.'
          : error.message;
        cartLink.hidden = false;
      } finally {
        this.busy = false;
        this.render();
        this.removeAttribute('aria-busy');
      }
    }
  });
}

